import TextField from '@mui/material/TextField';
import { isValid } from 'date-fns';
import { memo } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { FilterTestIds } from '../../../../utils/testIds/Filter.testIds';

export interface DateFilterFieldProps {
  value: string;
  onChange: (date: Date | null) => void;
  label: LangEnum;
  error?: boolean;
}

const MAX_DATE = '9000-01-01';

const DateFilterField = ({ onChange, value, label, error }: DateFilterFieldProps) => {
  const { translate } = useTranslation();
  return (
    <TextField
      test-id={`${FilterTestIds.DATE_FIELD_PREFIX}${label}`}
      label={translate(label)}
      fullWidth
      type="date"
      size="small"
      variant="outlined"
      value={value}
      onChange={(event) => {
        const date = new Date(`${event.target.value}T00:00:00`);
        return onChange(isValid(date) ? date : null);
      }}
      error={error}
      slotProps={{
        htmlInput: {
          max: MAX_DATE,
        },

        inputLabel: {
          shrink: true,
        },
      }}
    />
  );
};

export default memo(DateFilterField);
